export default "__VITE_ASSET__XF852xzc__"